// DEFAULT STATE
const defaultState = {
  collection: [],
}

// ACTIONS
export const FETCH_COMPETING_INTERVIEW_REQUESTS = 'company/candidateDetails/competingInterviewRequests/FETCH_COMPETING_INTERVIEW_REQUESTS'
export const FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS =
  'company/candidateDetails/competingInterviewRequests/FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS'

export const RESET_COMPETING_INTERVIEW_REQUESTS = 'company/candidateDetails/competingInterviewRequests/RESET'

export const fetchCompetingInterviewRequests = (hiringTeamId, candidateProfileId) => ({
  type: FETCH_COMPETING_INTERVIEW_REQUESTS,
  meta: {
    candidateProfileId,
    hiringTeamId,
  },
})

export const fetchCompetingInterviewRequestsSuccess = ({ result }) => ({
  type: FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS,
  payload: {
    collection: result,
  },
})

export const resetCompetingInterviewRequests = () => ({
  type: RESET_COMPETING_INTERVIEW_REQUESTS,
})

// REDUCERS

const collection = (state = defaultState, { type, payload }) => {
  switch (type) {
    case FETCH_COMPETING_INTERVIEW_REQUESTS:
    case FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS:
      return { ...state, ...payload }

    case RESET_COMPETING_INTERVIEW_REQUESTS:
      return defaultState

    default:
      return state
  }
}

export default collection
